import React, { useState, useEffect } from "react";
import {connect, useDispatch} from "react-redux";
import Button from "../../../shared/component/button/Button";
import T from "../../../shared/component/t/T";
import User from "../../../helpers/User";
import {_loading} from "../../../actions/Loading";
import * as c from "../../../core/constants/ReportStatus";
import {Link} from "react-router-dom";
import BaseApi from "../../../core/api/BaseApi";
import {withRouter} from "../../../helpers/withRouter";
import * as Sentry from '@sentry/react';
import ReportCP_Diffs from "./ReportCP_Diffs";
import snippets from "../../../helpers/snippets";

const baseApi = new BaseApi();

function ReportCP_Buttons(props) {

    const dispatch = useDispatch()
    const [ NewStudyReport, setNewStudyReport ] = useState(props.NewStudyReport)
    const [diffViewer, setDiffViewer] = useState({status: false, event: null, old: props.source})

    useEffect(() => {
        setNewStudyReport(props.NewStudyReport )
    }, [props.NewStudyReport]);

    const showDiffs = async (e) => {
        let diffs = snippets.objectsDifferKeys(props.source, NewStudyReport)
        // diffs.map(key => console.log(props.source[key], NewStudyReport[key]))
        let [hasDiffs, old] = await handleShowDiffs(diffs)
        if ( hasDiffs ) setDiffViewer({...diffViewer ,status: true, event: e, old: old})
        else handleButtonClick(e)
    }

    const handleShowDiffs = async (subset) => {
        if (snippets.isObjectEmpty(NewStudyReport.id) || NewStudyReport.id === 0) {
            return [false, {}]
        }
        let set = ["description_name", "findings", "impression", "typist_id", "reporter_id", "resident2_id", "verifier_id"]
        let diffs = subset?.length >= 1 && subset?.every(val => set.includes(val))
        if (diffs) {
            dispatch(_loading(true));
            try {
                const res = await baseApi.fullFetch("study", "get", {data: {id: NewStudyReport.study_id}});
                let obj = res.data.study.reports[NewStudyReport.id];
                dispatch(_loading(false));
                return [true, obj];
            } catch (error) {
                dispatch(_loading(false));
                return [true, props.source];
            }
        } else {
            return [false, {}]
        }
    }

    const confirm = () => {
        setDiffViewer({...diffViewer, status: false})
        handleButtonClick(diffViewer.event)
    }

    const closeDiffViewer = () => {
        setDiffViewer({...diffViewer, status: false, event: null})
    }

    const handleButtonClick = (e) => {
        dispatch(_loading(true));
        let someProperty = { ...NewStudyReport }
        switch (e.target.name) {
            case "save":
                sendInfosToServer(someProperty)
                break;
            case "typed":
                someProperty['status'] = c.REPORT_STATUS_TYPED
                sendInfosToServer(someProperty)
                break;
            case "accepted":
                someProperty['status'] = c.REPORT_STATUS_ACCEPTED
                sendInfosToServer(someProperty)
                break;
            case "verify":
                someProperty['with_staff'] = null;
                someProperty['status'] = c.REPORT_STATUS_VERIFIED
                sendInfosToServer(someProperty)
                break;
            case "send_to_his":
                for (let key in someProperty) {
                    if (key !== "id" && key !== "study_id") {
                        delete someProperty[key];
                    }
                }
                someProperty['status'] = c.REPORT_STATUS_SENT_TO_HIS
                sendInfosToServer(someProperty)
                break;
            case "Verify_with_staff":
                someProperty['with_staff'] = true
                someProperty['status'] = c.REPORT_STATUS_VERIFIED;
                sendInfosToServer(someProperty)
                break;
            case "Verify_without_staff":
                someProperty['with_staff'] = false
                someProperty['status'] = c.REPORT_STATUS_VERIFIED;
                sendInfosToServer(someProperty)
                break;
            default:
                console.log("ReportCP: which button clicked?")
        }
    }

    const sendInfosToServer = (data) => {
        // Sentry.captureMessage('User clicked on report button', {extra: {NewStudyReport: NewStudyReport}});
        let {history, ..._data} = data
        baseApi.fullFetch("report", Number(data.id) === 0 ? "post" : "put", {data: _data, showMessageSuccess: true})
            .then((response)=>{
                serverRespond(response.data.report)
            }).catch((e)=>{
                console.error('sendInfosToServer failed', e)
        })
    }

    const serverRespond = (res) => {
        props.serverRespond(res)
    }

    return (
        <>
            <div className='buttons'>
                {User.canEditReport(NewStudyReport) &&
                    <Button size="big" customClasses="margin-10px" name={"save"} buttonText={`save`} mode="white" onClick={showDiffs} />
                }
                {(User.canEditReport(NewStudyReport) && User.isTypist()) &&
                    <Button size="big" customClasses="margin-10px" name={"typed"} buttonText={"typed"} mode="typed" onClick={showDiffs} />
                }
                {(User.canAcceptReport(NewStudyReport) && !User.isStaff()) &&
                    <Button size="big" customClasses="margin-10px" name={"accepted"} buttonText={"accepted"} mode="typed" onClick={showDiffs} />
                }
                {User.canVerifyReport(NewStudyReport) &&
                    <Button size="big" customClasses="margin-10px" name={"verify"} buttonText={"verify"} mode="admitted" onClick={showDiffs} />
                }
                {User.canVerifyWithStaffReport(NewStudyReport) &&
                    <Button size="big" customClasses="margin-10px" name={"Verify_with_staff"} buttonText={"Verify_with_staff"} mode="stuff" onClick={showDiffs} />
                }
                {User.canVerifyWithoutStaffReport(NewStudyReport) &&
                    <Button size="big" customClasses="margin-10px" name={"Verify_without_staff"} buttonText={"Verify_without_staff"} mode="stuff" onClick={showDiffs} />
                }
                {User.canSendToHISReport(NewStudyReport) &&
                    <Button size="big" customClasses="margin-10px" name={"send_to_his"} buttonText={"send_to_his"} mode="his" onClick={showDiffs} />
                }
                {User.canPrintReport(NewStudyReport) &&
                    <Link target="_blank" to={`/print/${props.params.studyID}/${props.reportID}`} rel="noreferrer" replace={true} className={'print_report_link'}
                          onClick={()=>dispatch(_loading(false))}
                    >
                        <span className={"icon"}><i className={"fal fa-print 2x"} /></span>
                        <span className={"buttonText"}><T token={"print"} /></span>
                    </Link>
                }
            </div>

            {diffViewer.status && <ReportCP_Diffs show={diffViewer.status}
                                                  new={NewStudyReport}
                                                  old={diffViewer.old}
                                                  onClose={closeDiffViewer}
                                                  applyChanges={confirm}
                                                  button={diffViewer.event}
            />}
        </>

    )
}

const mapStateToProps = state => {
    const language = state.LangReducer.language;
    return {language};
};

export default connect(mapStateToProps)(withRouter(ReportCP_Buttons));